import { render, staticRenderFns } from "./HumanResourcesEvaluation.vue?vue&type=template&id=1c20ee6b&scoped=true"
import script from "./HumanResourcesEvaluation.vue?vue&type=script&lang=js"
export * from "./HumanResourcesEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20ee6b",
  null
  
)

export default component.exports